var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCutleryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 153,
    viewBox: "0 0 202 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 289431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 289237"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3291",
    x: 94.4619,
    y: 11.7656,
    width: 33.1452,
    height: 5.47353,
    rx: 2.73676,
    fill: "#F2F4F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3294",
    x: 67.7031,
    y: 0.820312,
    width: 56.5598,
    height: 5.47353,
    rx: 2.73676,
    fill: "#F2F4F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3290",
    x: 51.8145,
    y: 10.5508,
    width: 143.872,
    height: 63.5112,
    transform: "rotate(19.5091 51.8145 10.5508)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M134.949 83.5012C134.292 113.672 112.714 134.454 85.3618 133.088C55.753 131.607 34.9323 112.055 35.7747 83.5012C36.5835 56.1275 56.3308 33.9141 85.3618 33.9141C114.393 33.9141 135.545 56.1214 134.949 83.5012Z",
    fill: "#E1E2E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.7536 150.361C36.7536 150.361 32.4585 152.581 28.0969 136.741C23.7323 120.903 23.2419 110.198 21.6494 103.439C20.0569 96.6807 16.6589 83.1774 16.6589 83.1774C16.6589 83.1774 10.62 81.3874 7.64867 71.2064C5.04296 62.2847 1.91453 44.6639 1.91453 44.6639C1.91453 44.6639 1.68409 43.3322 2.51605 43.1365C2.81202 43.0664 3.10853 43.1689 3.54577 44.2432C4.69379 47.0749 9.58125 65.4887 9.58125 65.4887C9.58125 65.4887 10.1344 66.9759 10.7648 66.7536C11.0414 66.6572 11.2137 66.4243 10.981 64.9864C10.3829 61.3157 6.11952 43.7144 6.11952 43.7144C6.11952 43.7144 5.82761 42.5461 6.57884 42.3053C6.88051 42.2086 7.13193 42.1972 7.58409 43.1954C8.71335 45.6865 13.2279 64.5419 13.2279 64.5419C13.2279 64.5419 13.6234 65.9535 14.5245 65.7211C14.8248 65.6437 15.0494 65.3942 14.9407 64.1692C14.6546 60.9048 10.1107 42.4715 10.1107 42.4715C10.1107 42.4715 9.85739 41.4408 10.5435 41.1665C10.8589 41.0381 11.1382 41.0006 11.6575 42.0035C12.8988 44.3934 17.8754 63.6886 17.8754 63.6886C17.8754 63.6886 18.365 64.7588 18.9452 64.4271C19.1699 64.3 19.444 64.1571 19.2899 62.9752C18.9285 60.1982 14.3921 41.295 14.3921 41.295C14.3921 41.295 14.0842 40.3444 14.5892 40.2204C14.958 40.1284 15.2064 40.0078 15.7307 41.0911C16.7757 43.2553 22.8091 64.225 22.8091 64.225C22.8091 64.225 27.162 76.1097 21.4976 81.9452C21.4976 81.9452 25.6449 98.5243 26.7631 102.105C27.885 105.688 29.4085 109.317 31.8773 116.004C34.3433 122.691 37.2973 133.426 38.2665 137.903C39.2365 142.382 40.2691 149.624 36.7469 150.347L36.7536 150.361Z",
    fill: "#BDBDC2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M86.3531 118.581C85.9304 118.581 85.5077 118.572 85.082 118.554C75.3391 118.119 67.5819 115.437 62.6467 110.793C55.9264 104.468 49.3946 97.213 49.7778 84.2681C49.9937 76.9518 51.8456 70.2711 55.1297 64.9496C62.3152 53.3093 70.9664 48.5625 84.9817 48.5625C95.0408 48.5625 102.077 51.1199 110.084 57.6881C117.05 63.4018 120.897 72.4088 121.204 83.739C121.545 96.1974 116.305 106.101 106.052 112.381C99.3345 116.495 92.7054 118.581 86.347 118.581H86.3531ZM84.9847 50.3809C71.6871 50.3809 63.489 54.8783 56.6805 65.9045C53.5606 70.9553 51.803 77.3259 51.5962 84.3229C51.2374 96.5106 57.4742 103.429 63.8934 109.468C68.5064 113.807 75.8622 116.322 85.1641 116.735C85.5625 116.754 85.9578 116.763 86.3531 116.763C92.3709 116.763 98.6807 114.768 105.106 110.83C114.91 104.824 119.714 95.726 119.389 83.7877C119.094 73.0018 115.478 64.4631 108.931 59.093C101.287 52.8227 94.5725 50.3779 84.9817 50.3779L84.9847 50.3809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M86.633 92.7164C86.633 92.7164 81.3328 91.7859 77.5257 91.7828C72.2316 91.7828 66.1803 88.6812 66.3536 80.4922C66.5026 73.4678 60.6763 66.486 57.1064 64.6281C51.7028 61.8153 50.1155 52.9907 54.4517 47.3256C58.791 41.6605 54.8288 39.5472 54.9504 35.6427C55.0447 32.7113 58.9917 21.5605 67.8832 28.0619C67.8832 28.0619 70.6047 30.5827 71.3132 33.0276C72.0248 35.4724 75.616 37.7135 78.7755 37.598C81.9349 37.4824 92.4988 40.5658 87.5149 50.8956C83.2516 59.7293 84.6656 63.0134 86.183 64.2905C87.7004 65.5677 96.9628 75.5173 89.2846 86.9752C89.2846 86.9752 86.7121 90.7033 86.633 92.7133V92.7164Z",
    fill: "#BDBDC2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M88.871 102.295C88.871 102.295 88.8436 102.295 88.8314 102.295C88.0773 102.274 87.4843 101.644 87.5056 100.89C87.7063 93.9876 80.3232 84.9046 80.2502 84.8164C79.9704 84.4789 73.4904 76.4571 72.122 61.2468C70.7688 46.1825 64.1094 37.9296 61.6007 34.8219C61.1263 34.235 61.2206 33.3775 61.8044 32.9031C62.3913 32.4318 63.2518 32.523 63.7232 33.1068C66.3717 36.3909 73.4113 45.1091 74.8375 61.0005C76.1237 75.3107 82.2875 83.001 82.3514 83.0771C82.4274 83.1683 90.4644 92.9355 90.2302 100.969C90.2089 101.708 89.6008 102.295 88.8679 102.295H88.871Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 25",
    d: "M166.227 17.2403C166.227 26.4771 158.739 33.9649 149.502 33.9649C140.265 33.9649 132.777 26.4771 132.777 17.2403C132.777 8.00351 140.265 0.515625 149.502 0.515625C158.739 0.515625 166.227 8.00351 166.227 17.2403ZM137.48 17.2403C137.48 23.88 142.862 29.2626 149.502 29.2626C156.142 29.2626 161.524 23.88 161.524 17.2403C161.524 10.6005 156.142 5.21798 149.502 5.21798C142.862 5.21798 137.48 10.6005 137.48 17.2403Z",
    fill: "#E1E2E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 26",
    d: "M141.899 132.943C141.899 136.889 138.7 140.089 134.753 140.089C130.807 140.089 127.607 136.889 127.607 132.943C127.607 128.996 130.807 125.797 134.753 125.797C138.7 125.797 141.899 128.996 141.899 132.943ZM129.617 132.943C129.617 135.78 131.916 138.08 134.753 138.08C137.59 138.08 139.89 135.78 139.89 132.943C139.89 130.106 137.59 127.806 134.753 127.806C131.916 127.806 129.617 130.106 129.617 132.943Z",
    fill: "#E1E2E3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3292",
    x: 144.94,
    y: 73.1914,
    width: 56.5598,
    height: 5.47353,
    rx: 2.73676,
    fill: "#F2F4F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3293",
    x: 141.899,
    y: 87.1797,
    width: 7.60212,
    height: 5.47353,
    rx: 2.73676,
    fill: "#F2F4F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutleryIcon);
export default __webpack_public_path__ + "static/media/cutlery-icon.37cbb87867cad6d80e682f05de7d7b66.svg";
export { ForwardRef as ReactComponent };